import {
  Component,
  input,
  output,
  effect,
  ElementRef,
  inject,
  signal
} from '@angular/core';
import { UmssIconComponent } from '../icon/icon.component';
import { fadeIn } from '../../animations';
import { calculateContrastColor } from '@umss/shared/utils';

@Component({
  selector: 'umss-bottom-action-bar',
  standalone: true,
  imports: [UmssIconComponent],
  templateUrl: './bottom-action-bar.component.html',
  styleUrls: ['./bottom-action-bar.component.scss'],
  animations: [fadeIn],
  host: { '[@fadeIn]': '' }
})
export class UmssBottomActionBarComponent {
  backgroundColor = input<string>('var(--color-Primary)');
  title = input.required<string>();
  subtitle = input<string>('');
  iconName = input<string>('phosphorArrowRight');

  actionClick = output<void>();

  textColor = signal<string>('var(--white, #ffffff)');

  private el = inject(ElementRef);

  constructor() {
    // Dynamically react to changes in the background color signal
    effect(() => {
      // Trigger effect when backgroundColor changes
      this.backgroundColor();

      // requestAnimationFrame ensures we evaluate the color *after* the browser paints the style to the DOM
      requestAnimationFrame(() => {
        const button =
          this.el.nativeElement.querySelector('.bottom-action-bar');
        if (!button) return;

        // Extracts the exact computed RGB background color
        const rgb = getComputedStyle(button).backgroundColor;
        this.textColor.set(calculateContrastColor(rgb));
      });
    });
  }
}
